import { withInstall } from '@lit-element/utils'

import Slider from './src/slider.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtSlider: SFCWithInstall<typeof Slider> = withInstall(Slider)
export default LtSlider

export * from './src/slider'
export * from './src/constants'
